module.exports = __webpack_public_path__ + "a9f682e66f8bfb54f1d689c7b3478b10.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-4.svg
// module id = 488
// module chunks = 0